"use client";

import { HomeStore } from "@store";
import Link from "next/link";
import { OspIcons } from "@ospweb/sdk-ui/src/Icon/OspIcons";
import React from "react";
import type { SideMenuNavItemConfig } from "./sideMenuNavConfig";
import { cn } from "utils/src/cn";
import { getSideMenuNavItemClasses } from "./sideMenuNavPresentation";
import { usePathname } from "@/src/hooks/usePathname";
import { useSnapshot } from "valtio";

export function GoalMenuIcon({
  className,
  size = 20,
}: {
  className?: string;
  size?: number;
}) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="none"
      height={size}
      viewBox="0 0 17.5 17.5"
      width={size}
    >
      <path
        d="M14.9155 2.58252L16.7486 2.94893C16.847 2.96862 16.928 3.04081 16.9564 3.13815C16.9708 3.18544 16.972 3.23573 16.9601 3.28369C16.9482 3.33164 16.9235 3.37546 16.8886 3.41049L15.3869 4.91331C15.2069 5.09224 14.9636 5.19287 14.7098 5.19331H13.4641L10.3359 8.32252C10.3956 8.54786 10.4066 8.78333 10.3681 9.01324C10.3297 9.24315 10.2427 9.46222 10.1129 9.65587C9.98313 9.84952 9.81358 10.0133 9.61556 10.1363C9.41754 10.2593 9.19558 10.3386 8.96447 10.3691C8.73337 10.3996 8.49842 10.3804 8.27529 10.313C8.05216 10.2456 7.84596 10.1313 7.67043 9.97794C7.4949 9.82456 7.35407 9.63552 7.25733 9.42344C7.16059 9.21136 7.11015 8.9811 7.10938 8.74799C7.10932 8.49624 7.16721 8.24785 7.27855 8.02205C7.38989 7.79626 7.5517 7.59912 7.75146 7.44589C7.95121 7.29266 8.18355 7.18746 8.43049 7.13843C8.67742 7.0894 8.93233 7.09786 9.17547 7.16315L12.3047 4.03284V2.78924C12.3047 2.53549 12.4053 2.29159 12.5847 2.11221L14.0875 0.6094C14.1225 0.574541 14.1664 0.549827 14.2143 0.537887C14.2623 0.525946 14.3126 0.527225 14.3598 0.541588C14.4572 0.570025 14.5294 0.650963 14.5491 0.7494L14.9155 2.58252Z"
        fill="currentColor"
      />
      <path
        d="M2.18687 8.75085C2.18799 9.68924 2.39035 10.6165 2.7803 11.47C3.17025 12.3236 3.73871 13.0835 4.44735 13.6987C5.15598 14.3139 5.98831 14.7699 6.88817 15.036C7.78804 15.3022 8.73451 15.3722 9.66375 15.2415C10.593 15.1107 11.4834 14.7822 12.2749 14.2781C13.0664 13.7739 13.7405 13.1059 14.2519 12.3191C14.7632 11.5323 15.0999 10.645 15.2392 9.71695C15.3785 8.78895 15.3171 7.84187 15.0592 6.9396C15.023 6.83419 15.0086 6.72251 15.017 6.61136C15.0253 6.50022 15.0562 6.39193 15.1077 6.2931C15.1592 6.19426 15.2303 6.10695 15.3166 6.03646C15.403 5.96598 15.5028 5.91381 15.6099 5.88312C15.7171 5.85243 15.8293 5.84387 15.9399 5.85796C16.0505 5.87204 16.157 5.90849 16.253 5.96506C16.3491 6.02164 16.4326 6.09717 16.4985 6.18705C16.5644 6.27693 16.6113 6.37928 16.6364 6.48788C17.1357 8.23518 17.0409 10.0988 16.3667 11.7864C15.6926 13.4739 14.4773 14.89 12.9115 15.8123C11.3458 16.7347 9.5181 17.1111 7.71528 16.8827C5.91246 16.6542 4.23649 15.8337 2.9503 14.5499C1.66552 13.264 0.844153 11.5879 0.615153 9.78468C0.386153 7.98144 0.762491 6.15321 1.68508 4.58702C2.60767 3.02084 4.02426 1.80539 5.71246 1.1315C7.40065 0.45762 9.26483 0.363464 11.0123 0.863818C11.2204 0.924643 11.3959 1.06536 11.5006 1.25522C11.6052 1.44508 11.6305 1.66864 11.5708 1.87704C11.5111 2.08545 11.3713 2.26175 11.182 2.36743C10.9928 2.4731 10.7693 2.49956 10.5606 2.44101C9.58343 2.1604 8.55441 2.11068 7.55472 2.29576C6.55503 2.48083 5.61201 2.89565 4.80005 3.50749C3.98808 4.11933 3.32938 4.91145 2.87588 5.82138C2.42239 6.73132 2.18652 7.73417 2.18687 8.75085Z"
        fill="currentColor"
      />
      <path
        d="M5.4679 8.74972C5.46796 9.34755 5.63125 9.93402 5.94014 10.4459C6.24903 10.9577 6.69181 11.3755 7.22071 11.6542C7.74961 11.9329 8.34457 12.0619 8.9414 12.0273C9.53823 11.9927 10.1143 11.7958 10.6074 11.4578C11.1005 11.119 11.4915 10.6519 11.7383 10.1069C11.985 9.56193 12.0781 8.95986 12.0074 8.36581C11.9883 8.22166 12.008 8.07501 12.0644 7.94097C12.1208 7.80694 12.2119 7.69036 12.3283 7.60323C12.4447 7.5161 12.5823 7.46158 12.7268 7.44529C12.8713 7.42899 13.0175 7.4515 13.1504 7.5105C13.2833 7.56873 13.3983 7.66117 13.4838 7.77837C13.5693 7.89558 13.6222 8.03337 13.6371 8.17769C13.756 9.1928 13.5558 10.2197 13.0646 11.1159C12.5733 12.0122 11.8152 12.7332 10.8955 13.179C9.97577 13.6248 8.94011 13.7732 7.93222 13.6037C6.92434 13.4342 5.99423 12.9551 5.27098 12.2329C4.54774 11.5108 4.06725 10.5814 3.89618 9.57379C3.72512 8.56616 3.87198 7.53027 4.31638 6.6099C4.76078 5.68953 5.48068 4.93033 6.37614 4.43768C7.27161 3.94502 8.29824 3.74335 9.31352 3.86065C9.42224 3.87074 9.52784 3.90243 9.62415 3.95386C9.72046 4.00529 9.80553 4.07543 9.87438 4.16016C9.94323 4.2449 9.99448 4.34252 10.0251 4.44732C10.0557 4.55212 10.0651 4.66197 10.0528 4.77045C10.0404 4.87892 10.0065 4.98384 9.95303 5.07904C9.89958 5.17424 9.82766 5.25782 9.7415 5.32487C9.65533 5.39192 9.55664 5.44109 9.45123 5.4695C9.34581 5.49792 9.23578 5.505 9.12759 5.49034C8.66784 5.43696 8.202 5.48145 7.76066 5.62088C7.31932 5.76031 6.91248 5.99153 6.56684 6.29936C6.22121 6.60719 5.94461 6.98465 5.75521 7.40696C5.56581 7.82928 5.4679 8.28688 5.4679 8.74972Z"
        fill="currentColor"
      />
    </svg>
  );
}

interface SideMenuNavItemProps {
  item: SideMenuNavItemConfig;
  label: string;
  closeLabel?: string;
  href: string;
  localePrefix: string;
  onCancel?: () => void;
  onClick?: (event?: React.MouseEvent) => void;
  suffix?: React.ReactNode;
  showDot?: boolean;
  className?: string;
}

export const SideMenuNavItem: React.FC<SideMenuNavItemProps> = ({
  item,
  label,
  closeLabel,
  href,
  localePrefix,
  onCancel,
  onClick,
  suffix,
  showDot = false,
  className,
}) => {
  const pathname = usePathname();
  const { isOpen } = useSnapshot(HomeStore);
  const isCurrent = item.isActive(pathname);
  const {
    link,
    icon,
    label: labelClass,
    iconWrap,
    iconSize,
  } = getSideMenuNavItemClasses({
    tier: item.tier,
    isCurrent,
    isOpen,
  });

  return (
    <Link
      aria-label={label}
      aria-current={isCurrent ? "page" : undefined}
      data-openreplay-label={`Menu Guide Link | ${localePrefix}${href}`}
      data-testid={`side-menu-nav-${item.id}`}
      {...(item.id === "brief"
        ? { "data-handoff-anchor": "first_brief" as const }
        : item.id === "invest" || item.id === "plan" || item.id === "track"
          ? { "data-handoff-anchor": "territory" as const }
          : {})}
      className={cn(link, className)}
      href={`${localePrefix}${href}`}
      onClick={(event) => {
        if (onClick) {
          onClick(event);
          return;
        }
        onCancel?.();
      }}
      data-tracking-scope={item.trackingScope}
    >
      <div className={iconWrap}>
        {item.icon === "goal-custom" ? (
          <GoalMenuIcon className={icon} size={iconSize} />
        ) : (
          <OspIcons name={item.icon} size={iconSize} className={icon} />
        )}
        {showDot ? (
          <span className="absolute -right-1 -top-1 size-2 rounded-full bg-content_accent4_primary" />
        ) : null}
      </div>
      <span className={labelClass}>{isOpen ? label : closeLabel || label}</span>
      {!!suffix ? <div>{suffix}</div> : null}
    </Link>
  );
};
